<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      labelWidth="100px"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "guanliyuanyonghu",
  components: {},
  data() {
    return {
      url: "/user/page",
      columns: [
        {
          label: "管理员账号",
          prop: "loginName"
        },
        {
          label: "管理员姓名",
          prop: "userName"
        },
        {
          label: "角色",
          prop: "roleNames"
        },
        {
          label: "手机号",
          prop: "mobile"
        },
        {
          label: "状态",
          prop: "frozen",
          template: function(index, reocrd) {
            return reocrd.frozen
              ? "<span class='tag danger'>冻结</span>"
              : "<span class='tag success'>正常</span>";
          }
        }
      ],
      // 操作栏
      handles: {
        width: 260,
        btns: [
          {
            label: "修改",
            permission: "user.manage.adminuser.pageupdate",
            style: "color:#00CC00",
            handle: resp => {
              this.$router.push({path:"./reviseAdministrators",query:{data:resp}})
            }
          },
          {
            label: "密码重置",
            permission: "user.manage.adminuser.reset",
            url: "/user/resetPwd",
            style: "color:#00CC00",
            method: "post",
            isConfirm: true,
            confirmText: "是否确定将密码重置为888888？",
            before: (index, record) => {
              let p = {
                id: record.id
              };
              return p;
            },
            handle: resp => {
              this.$notify({
                title: "成功",
                message: "重置密码成功",
                type: "success"
              });
            }
          },
          {
            label: "冻结",
            permission: "user.manage.adminuser.freeze",
            style: "color:red",
            getLabel: function(record) {
              return record.frozen ? "恢复" : "冻结";
            },
            url: "/user/frozen",
            method: "post",
            isConfirm: true,
            confirmText: "是否确定本操作？",
            before: function(index, record) {
              let p = {
                  id: record.id,
              };
              return p;
            },
            handle: resp => {
              this.$refs.tableref.queryTable();
            }
          },
          {
            label: "删除",
            permission: "user.manage.adminuser.delete",
            style: "color:red",
            isConfirm: true,
            url: "/user",
            method: "delete",
            confirmText:"删除后账号将不可恢复，确认删除?",
            before: (index, record) => {
              let arr = [];
              arr.push(record.id);
              return {
                ids: arr
              };
            },
            handle: resp => {
              this.$refs.tableref.queryTable();
            }
          }
        ]
      },
      query: [
        {
          label: "管理员账号",
          prop: "loginName",
          placeholder: "请输入管理员账号"
        },
        {
          label: "管理员姓名",
          prop: "userName",
          placeholder: "请输入管理员姓名"
        },
        {
          label: "手机号",
          prop: "mobile",
          placeholder: "请输入手机号"
        },
        {
          label: "状态",
          prop: "frozen",
          type: "select",
          data: [
            {
              label: "正常",
              value: "false"
            },
            {
              label: "冻结",
              value: "true"
            }
          ]
        }
      ],
      toolbar: [
        {
          label: "新增",
          permission: "user.manage.adminuser.pageadd",
          type: "success",
          handle: resp => {
            this.$router.push("./addAdministrators")
          }
        }
      ],
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/BMS/userManagement/administrators.vue